<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Facility', apiMethod: 'Facilities', form: () => import('../forms/FacilityForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Cleaning', apiMethod: 'Cleanings', parentForeignKey: 'facilityId', form: () => import('../forms/CleaningForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Facility Setup', apiMethod: 'FacilitySetups', parentForeignKey: 'facilityId', form: () => import('../forms/FacilitySetupForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Cleanings', value: 'facilityId', isCard: true, table: () => import('../tables/CleaningsTable') },
                    { text: 'Containers', value: 'facilityId', table: () => import('../tables/ContainersTable') },
                    { text: 'Equipment Items', value: 'facilityId', table: () => import('../tables/EquipmentItemsTable') },
                    { text: 'Setups', value: 'facilityId', isCard: true, table: () => import('../tables/FacilitySetupsTable') },
                    { text: 'Harvestings', value: 'facilityId', table: () => import('../tables/HarvestingsTable') },
                    { text: 'Pest Controls', value: 'facilityId', table: () => import('../tables/PestControlsTable') },
                    { text: 'Products', value: 'facilityId', table: () => import('../tables/ProductsTable') },
                    { text: 'Temperature Checks', value: 'facilityId', table: () => import('../tables/TemperatureChecksTable') },
                ],
                mainForm: () => import('../forms/FacilityForm'),
                claimName: 'Facilities',
                apiMethod: 'Facilities',
            }
        }
    };
</script>
